import React from 'react';
import { Activity } from '@bingads-webui-react/hoc-with-signal';
import { STEP_PATHS } from '../step-constants';
import { AssetGroupStepShell, useAssetGroupRepository } from './asset-group';
import { CampaignSettingStepShell } from './campaign-setting';
import { CampaignTargetingStepShell } from './campaign-targeting';
import { useCampaignRepository } from '../shared/use-campaign-repository';

const assetGroupStepConfig = {
  id: STEP_PATHS.ASSET_GROUP,
  view: props => <Activity name="AssetGroup"> <AssetGroupStepShell {...props} /> </Activity>,
  repository: useAssetGroupRepository,
};

const campaignTargetingStepConfig = {
  id: STEP_PATHS.CAMPAIGN_TARGETING,
  view: props => <Activity name="CampaignTargeting"> <CampaignTargetingStepShell {...props} /> </Activity>,
  repository: useCampaignRepository,
};

const campaignSettingStepConfig = {
  id: STEP_PATHS.CAMPAIGN_SETTING,
  view: props => <Activity name="CampaignSetting"> <CampaignSettingStepShell {...props} /> </Activity>,
  repository: useCampaignRepository,
};

export const StepConfigCampaignCreation = [
  assetGroupStepConfig,
  campaignTargetingStepConfig,
  campaignSettingStepConfig,
];

export const StepConfigCampaignEdit = [
  campaignTargetingStepConfig,
  campaignSettingStepConfig,
];

export const StepConfigAssetGroupCreation = [
  assetGroupStepConfig,
  campaignTargetingStepConfig,
];

